import { UploadFail } from 'reactApp/modules/uploading/fails/UploadFail';

export class IllegalContentFail extends UploadFail {
    radarName = 'fail_{SOURCE}_illegal-content';
    message = 'Заблокированный контент.';
}
